﻿define([
	'pubsub', 'generalUtilities', 'stickySidebar'],

	function profileScrollControl(pubsub, generalUtilities) {
		'use strict';
		/**
		* re_profile_scroll_control
		* @exports profileScrollControl
		* @author John Allan
		*/
		// #region set up

		var module, selectors, elements, values;

		module = {};
		/** @module */
		module.private = {};
		module.properties = {};

		selectors = {
			pageContent: '.component-tabs',
			pageContentUserView: '.col_main',
			columnContainer: '.js-column-container',
			stickySidebar: '.js-profile-stickysidebar',
			stickySidebarInner: '.js-profile-stickysidebar-inner',
			anonymousNavigation: '.re-page-navigation-anonymous',
			leftSideBar: '.col_left',
			rightSideBar: '.col_right'
		};

		elements = {};
		values = {};

		// #endregion

		// #region utilities

		/**
		* Sticks the ProfileSideBar.
		* @example
		* module.private.stickProfileSideBar();
		*/
		module.private.stickProfileSideBar = function stickProfileSideBar() {
			var topSpacingAmount;

			if (values.profileSideBar) {
				module.private.unStickProfileSideBar();
			}

			topSpacingAmount = document.querySelector(selectors.anonymousNavigation) ? 20 : 70;
			
			// setup sticky nav
			values.profileSideBar = new StickySidebar(selectors.stickySidebar, {
				containerSelector: selectors.columnContainer,
				innerWrapperSelector: selectors.stickySidebarInner,
				topSpacing: topSpacingAmount,
				bottomSpacing: 20,
				//based below on _variables.scss
				//$mediaquery-nav-compact-max: "only screen and (max-width: 60em)"; which is 960px
				minWidth: 960
			});

			// watch the ProfileSideBar and page for size changes
			if (elements.pageContent) {
				values.ro.observe(elements.pageContent);
			}
			values.ro.observe(elements.navContainerInnerInner);
		};

		/**
		* Updates the ProfileSideBar posiiton.
		* @example
		* module.private.updateProfileSideBar();
		*/
		module.private.updateProfileSideBar = function updateProfileSideBar() {
			if (values.profileSideBar) {
				values.profileSideBar.updateSticky();
			}
		};

		/**
		* Unsticks the ProfileSideBar removing all styles and event bindings.
		* @example
		* module.private.unStickProfileSideBar();
		*/
		module.private.unStickProfileSideBar = function unStickProfileSideBar() {
			if (values.profileSideBar) {
				values.profileSideBar.destroy();
				delete values.profileSideBar;
			}

			if (elements.pageContent) {
				values.ro.unobserve(elements.pageContent);
			}
			values.ro.unobserve(elements.navContainerInnerInner);
		};

		// #endregion

		// #region pubsub event handlers

		/**
		* Handle layout mode based on window resize event
		*/
		module.private.updateProfileLayout = function updateProfileLayout(force) {
			var isProTablet;
			isProTablet = false;
			if (Modernizr) {
				isProTablet = Modernizr.mq('only screen and (min-width: 960px) and (max-width:1200px)');
			}

			// append right side bar to sticky based on screen width
			if (elements.rightBar) {
				if (force === true || values.previousIsProTablet !== isProTablet) {
					values.previousIsProTablet = isProTablet;
					if (isProTablet) {
						elements.stickyInner.insertAdjacentElement('beforeend', elements.rightBar);
					}
					else {
						elements.leftBar.insertAdjacentElement('afterend', elements.rightBar);
					}
				}
			}
		};

		// #endregion

		/**
		* Initiates the module, creates a guid and binds dom events.
		* @param {object} [e] The pubsub event, optional depending module is self init or by pubsub event.
		* @param {object} [data] Data passed in by pubsub event, optional depending module is self init or by pubsub event.
		*/
		module.private.init = function init(e, data) {
			var navigationState;

			if (!window.requestAnimationFrame || !Function.prototype.bind) {
				return false;
			}

			elements.window = $(window);
			elements.rightBar = document.querySelector(selectors.rightSideBar);
			elements.leftBar = document.querySelector(selectors.leftSideBar);
			elements.stickyInner = document.querySelector(selectors.stickySidebarInner);

			// module config
			module.properties.guid = (data && data.guid) ? data.guid : generalUtilities.uuid();

			// get current page state
			elements.stickySidebar = document.querySelector(selectors.stickySidebar);
			navigationState = generalUtilities.getNavigationState();

			// if sticky sideBar exists
			if (elements.stickySidebar) {
				// create resize observer
				values.ro = new ResizeObserver(function (entries, observer) {
					module.private.updateProfileSideBar();
				});

				// find DOM elements
				if (window.pageType === "activity-feed") {
					elements.pageContent = document.querySelector(selectors.pageContent);
				} else {
					elements.pageContent = document.querySelector(selectors.pageContentUserView);
				}
				
				elements.navContainerInnerInner = document.querySelector(selectors.stickySidebarInner);
				module.private.stickProfileSideBar();
			}

			module.private.updateProfileLayout(true);
			elements.window.off('resize.ProfileScrollControl')
				.on('resize.ProfileScrollControl', generalUtilities.debounce(module.private.updateProfileLayout,100));
		};

		// #region external event bindings

		module.private.init();

		// #endregion

		// expose API
		return module;
	}
);
